import { Root, Close } from '@radix-ui/react-toast';

import { styled } from '@lichtblick/styled';
import { Colors, Spacing } from '@lichtblick/theme';

export const ToastRoot = styled(Root)<{ $color: 'black' | 'white' }>`
  align-items: center;
  background: ${({ $color }) => ($color === 'black' ? Colors.black : Colors.white)};
  border-radius: 0.25rem;

  box-shadow: 0 0.25rem 0.5rem 0 rgba(16, 114, 186, 0.16);
  display: flex;
  gap: 1rem;
  padding: 1rem;
  width: 30.5rem;
  z-index: 3; //1 more than the dialog
`;

export const BannerRoot = styled.div`
  align-items: flex-start;
  background: ${Colors.red['10']};
  border: 1px solid ${Colors.red['100']};
  border-radius: 0.25rem;
  box-shadow: 0 0.25rem 0.5rem 0 rgba(16, 114, 186, 0.16);
  color: ${Colors.red['100']};
  display: flex;
  gap: 1rem;
  padding: 1rem;
  width: 100%;
  z-index: 3; //1 more than the dialog
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.Xxs};
  width: 100%;

  span {
    white-space: pre-wrap;
  }
`;

export const CloseButton = styled(Close)`
  pointer-events: auto;
`;
